import RankBadge from '@/components/VipClub/VipModal/Content/VipPerks/RankBadge';
import { CollapseButtonProps } from './props';
import styles from './styles.module.scss';

export default function CollapseButton({
  toggle,
  isLoading,
  isOpen,
  data,
}: CollapseButtonProps) {
  return (
    <div
      className={`${styles.container} ${isLoading ? styles['container--disabled'] : ''}`}
      onClick={toggle}
    >
      <RankBadge
        isLoading={isLoading}
        rankGroup={data}
        isSecondaryStyles
        showIcon
      />

      {isLoading ? (
        <div className={styles['chevron-skeleton']} />
      ) : (
        <i
          className={`${styles.container__chevron} ${isOpen ? styles['container__chevron--open'] : ''} fa-solid fa-chevron-down`}
        />
      )}
    </div>
  );
}
